function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.38379 11.2109C7.8315 11.2109 7.38379 11.6587 7.38379 12.2109C7.38379 12.7632 7.8315 13.2109 8.38379 13.2109H16.3433C16.8955 13.2109 17.3433 12.7632 17.3433 12.2109C17.3433 11.6587 16.8955 11.2109 16.3433 11.2109H8.38379Z",
  fill: "#4979C0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.42432 15.2775C7.87203 15.2775 7.42432 15.7252 7.42432 16.2775C7.42432 16.8298 7.87203 17.2775 8.42432 17.2775H16.3838C16.9361 17.2775 17.3838 16.8298 17.3838 16.2775C17.3838 15.7252 16.9361 15.2775 16.3838 15.2775H8.42432Z",
  fill: "#4979C0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.38379 3.21094C4.27922 3.21094 3.38379 4.10637 3.38379 5.21094V19.2109C3.38379 20.3155 4.27922 21.2109 5.38379 21.2109H19.3838C20.4884 21.2109 21.3838 20.3155 21.3838 19.2109V5.21094C21.3838 4.10637 20.4884 3.21094 19.3838 3.21094H5.38379ZM7.38379 5.21094H5.38379L5.38379 19.2109H19.3838V5.21094H17.3838V6.21094C17.3838 7.86779 16.0406 9.21094 14.3838 9.21094H10.3838C8.72693 9.21094 7.38379 7.86779 7.38379 6.21094V5.21094ZM9.38379 5.21094V6.21094C9.38379 6.76322 9.8315 7.21094 10.3838 7.21094H14.3838C14.9361 7.21094 15.3838 6.76322 15.3838 6.21094V5.21094H9.38379Z",
  fill: "#4979C0"
});

var SvgReports = function SvgReports(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReports, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reports.c3deb4e1.svg";
export { ForwardRef as ReactComponent };